import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer.js";
import anime from 'animejs/lib/anime.es.js';

export function About() {
    const animation = useRef(null);

    useEffect(() => {
        animation.current = anime({
          targets: '.about-content, .divider-h',
          translateY: [100, 0],
          opacity: [0, 1],
          duration: 1500,
          loop: false,
          delay: anime.stagger(200),
          easing: "easeOutExpo"
        })
    }, [])
    return (
        <>
            <div id="main">
            <div id="home-container">
            <h2 className="info-tite">Learn More</h2>
            <div id="home-animation">
            <div className="infopage-text about-content">
                <div className="readonly-container">
                    <h4>Lit Pro Archival</h4>
                    <p>Lit Pro was converted to a read-only website on January 2nd, 2026, due to a lack of engagement and rising infrastructure costs. For this reason, Lit Pro is no longer accepting new users or processing new literature reviews. If you have any questions, please reach out to us at <span>support@nexusstone.cloud</span></p>
                </div>
                <div className="divider-h"></div>
                <p style={{fontSize: "1.2rem"}}>Lit Pro utilizes a variety of <span>Machine Learning</span> (ML) and <span>Natural Language Processing</span> (NLP) techniques to create well-formatted, coherent literature reviews.</p>
                <div className="divider-h"></div>
                <p>To receive your literature review, all you need to do is:</p>
                <ol>
                    <li>Create an account <Link to="/signup"><span>here</span></Link>.</li>
                    <li>Make a one-time purchase for the literature review.</li>
                    <li>Upload the files you would like to include in your literature review.</li>
                    <li>Optional: Add a thesis statement to help our algorithm narrow its scope.</li>
                    <li>Receive your new literature review with citations!</li>
                </ol>
                <div className="divider-h"></div>
                <p>Some of the steps Lit Pro undergoes are:</p>
                <ul>
                    <li>Extracting the text of academic articles from multiple file types.</li>
                    <li>Preprocessing the text to remove punctuation and low-information words.</li>
                    <li>Generating an extractive summary of the text's most important sentences.</li>
                    <li>Refining the summary using abstractive mechanisms.</li>
                    <li>Clustering the texts according to shared topics.</li>
                    <li>Sorting the clusters by relevancy.</li>
                    <li>Producing the final literature review.</li>
                    <li>Creating citations for each article.</li>
                </ul>
                <div className="divider-h"></div>
                <p>By following these steps, Lit Pro is able to produce academically rigorous literature reviews that save you time and allow you to focus on your own research.</p>
            </div>
            <div style={{paddingBottom: "50px"}}></div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}